module.exports = __webpack_public_path__ + "img/literature.e7b6f2c9.svg";